export const setToken = jwtToken => ({ type: "SET_TOKEN", jwtToken });
export const setLogisticSensorToken = logisticSensorToken => ({ type: "SET_LOGISTIC_SENSOR_TOKEN", logisticSensorToken });
export const setCredit = credit => ({ type: "SET_CREDIT", credit });
export const setProgress = progress => ({ type: "SET_PROGRESS", progress });
export const signOut = () => ({ type: "SIGNOUT" });
export const setDemo = demo => ({ type: "SET_DEMO", demo });
export const setValidationBar = banner => ({ type: "SET_BANNER", banner });
